import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollTopButton from './components/ScrollTopButton';
import CachePopup from './components/CachePopup';
import Home from './pages/Home';
import About from './pages/About';
import Features from './pages/Features';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Login from './pages/Login';
import Register from './pages/Register';
import Plans from './pages/Plans';
import PublicPlans from './pages/PublicPlans';
import VerificationPending from './pages/VerificationPending';
import VerifyEmail from './pages/VerifyEmail';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import SubscriptionCancel from './pages/SubscriptionCancel';
import ManageSubscription from './pages/ManageSubscription';
import KidsPage from './pages/KidsPage';
import Gallery from './pages/Gallery';
import DeleteAccount from './pages/DeleteAccount';
import Profile from './pages/Profile';
import Reviews from './pages/Reviews';
import ScrollToTop from './components/ScrollToTop';
import { FontProvider } from './contexts/FontContext';
import './styles/fonts.css';
import './styles/App.css';

function AppContent({ language, setLanguage }) {
  const location = useLocation();
  const hideNavbarAndFooter = ['/register', '/login', '/plans', '/subscription', '/verification-pending', '/verify-email', '/payment-success', '/payment-cancelled', '/delete-account'].includes(location.pathname);

  return (
    <div className="app">
      {!hideNavbarAndFooter && <Navbar language={language} setLanguage={setLanguage} />}
      <Routes>
        <Route path="/" element={<Home language={language} />} />
        <Route path="/about" element={<About language={language} />} />
        <Route path="/features" element={<Features language={language} />} />
        <Route path="/contact" element={<Contact language={language} />} />
        <Route path="/privacy" element={<Privacy language={language} />} />
        <Route path="/terms" element={<Terms language={language} />} />
        <Route path="/login" element={<Login language={language} />} />
        <Route path="/register" element={<Register language={language} />} />
        <Route path="/plans" element={<Plans language={language} />} />
        <Route path="/pricing" element={<PublicPlans language={language} />} />
        <Route path="/subscription" element={<Plans language={language} />} />
        <Route path="/verification-pending" element={<VerificationPending language={language} />} />
        <Route path="/verify-email" element={<VerifyEmail language={language} />} />
        <Route path="/payment-success" element={<SubscriptionSuccess language={language} />} />
        <Route path="/payment-cancelled" element={<SubscriptionCancel language={language} />} />
        <Route path="/my-subscription" element={<ManageSubscription language={language} />} />
        <Route path="/kids" element={<KidsPage language={language} />} />
        <Route path="/gallery" element={<Gallery language={language} />} />
        <Route path="/delete-account" element={<DeleteAccount language={language} />} />
        <Route path="/profile" element={<Profile language={language} />} />
        <Route path="/reviews" element={<Reviews language={language} />} />
      </Routes>
      {!hideNavbarAndFooter && <Footer language={language} setLanguage={setLanguage} />}
      <ScrollTopButton />
      <CachePopup currentLanguage={language} />
    </div>
  );
}

function App() {
  const [language, setLanguage] = useState('fr');

  return (
    <FontProvider>
      <Router>
        <ScrollToTop />
        <AppContent language={language} setLanguage={setLanguage} />
      </Router>
    </FontProvider>
  );
}

export default App;
